module.exports = __webpack_public_path__ + "img/cibertec.79be5c18.png";